// src/components/AuthPages/ForgotPassword.jsx  →  /forgot
// Pide el email y dispara /api/forgot-password. Respuesta SIEMPRE genérica
// (anti-enumeración): no revela si el email existe.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import './AuthPages.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError('Ingresá un email válido.'); return; }
    setLoading(true);
    try {
      await fetch(`${API_URL}/api/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      setSent(true); // siempre mostramos el mismo mensaje
    } catch {
      setError('No se pudo conectar al servidor. Probá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ap-wrap">
      <div className="ap-card">
        <img src="/assets/Logo-White.png" alt="Bitplify" className="ap-logo" />
        <h1 className="ap-title">Recuperar contraseña</h1>

        {sent ? (
          <>
            <p className="ap-sub">Si ese email está registrado, te enviamos un enlace para restablecer tu contraseña. Revisá tu correo (y la carpeta de spam).</p>
            <div className="ap-msg ok">📬 Enlace enviado. El link vence en 30 minutos.</div>
            <p className="ap-foot"><Link className="ap-link" to="/login">← Volver a iniciar sesión</Link></p>
          </>
        ) : (
          <>
            <p className="ap-sub">Ingresá tu email y te mandamos un enlace para crear una nueva contraseña.</p>
            <form onSubmit={submit}>
              <div className="ap-field">
                <label className="ap-label">Email</label>
                <input
                  className="ap-input" type="email" placeholder="trader@email.com"
                  value={email} onChange={e => setEmail(e.target.value)} autoComplete="email"
                />
              </div>
              {error && <div className="ap-msg err">{error}</div>}
              <button type="submit" className="ap-btn" disabled={loading}>
                {loading ? <span className="ap-spin" /> : <>Enviar enlace <FiArrowRight /></>}
              </button>
            </form>
            <p className="ap-foot">¿Te acordaste? <Link className="ap-link" to="/login">Iniciar sesión</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
